export default __webpack_public_path__ + "72721b09000099251243b1eede12ed83.png";